import { useTranslation } from 'react-i18next';

import { MainLinks as MainLinksComponent } from 'us-react-components/dist/MainLinks/MainLinks';
import { useNavigate } from 'react-router-dom';
import { useDependencies } from '../../../dependencies';
import { getUrlFromPath, Routes } from '../../../Routes';

const MainLinks = (): JSX.Element => {
  const { t } = useTranslation();
  const { services: { tracker }, stores } = useDependencies();
  const id = stores.user.user.id?.toString() ?? '';
  const navigate = useNavigate();

  const mainLinksParent = [
    {
      link: getUrlFromPath(Routes.parent.sitters),
      trackingTag: 'main_links_search',
      label: t('components.header.mainLinks.search')
    },
    {
      link: getUrlFromPath(Routes.savedSearches),
      trackingTag: 'main_links_saved_searches',
      label: t('components.header.mainLinks.savedSearches')
    },
    {
      link: getUrlFromPath(Routes.parent.posts),
      trackingTag: 'main_links_posts',
      label: t('components.header.mainLinks.posts')
    },
    {
      link: getUrlFromPath(Routes.bookings.root),
      trackingTag: 'main_links_bookings',
      label: t('components.header.mainLinks.bookings')
    }
  ];

  const mainLinksSitter = [
    {
      link: getUrlFromPath(Routes.sitter.calendar),
      trackingTag: 'main_links_calendar',
      label: t('components.header.mainLinks.calendar')
    },
    {
      link: getUrlFromPath(Routes.sitter.profile, { id }),
      trackingTag: 'main_links_profile',
      label: t('components.header.mainLinks.profile')
    },
    {
      link: getUrlFromPath(Routes.sitter.jobBoard),
      trackingTag: 'main_links_job_board',
      label: t('components.header.mainLinks.jobBoard')
    },
    {
      link: getUrlFromPath(Routes.bookings.root),
      trackingTag: 'main_links_bookings',
      label: t('components.header.mainLinks.bookings')
    }
  ];

  const mainLinksArray = stores.user.user!.parent ? mainLinksParent : mainLinksSitter;

  const trackEvent = async (event: string, params?: {elementText: string}): Promise<void> => tracker.track(event, params);

  const navigationCallback = (path: string): void => {
    // Remove the `/app` prefix from the path
    // this will all be easier when AngularJS is gone
    const relativePath = path.replace(/^\/app/, '');
    navigate(relativePath);
  }

  return <MainLinksComponent
    mainLinksArray={mainLinksArray}
    navigationCallback={navigationCallback}
    trackingCallback={trackEvent}
  />
};

export default MainLinks;
